module.exports = __webpack_public_path__ + "static/media/laptop.0a18b993.svg";